export function fetchJobsData(BeURL, showAlert, searchTerm, page, pageNum, perPage, setJobs, setPagination) {
    fetch(`${BeURL}/job-list`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            page: page.toLowerCase(),
            pageNum,
            perPage,
            searchTerm
        })
    })
        .then(async res => {
            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err.message || `Server ${res.status}`);
            }
            return res.json();
        })
        .then(data => {
            if (data.success) {
                setJobs(data.jobs);
                setPagination(data.pagination);
            }
            else showAlert(data.message)
        })
        .catch(err => {
            console.error('Error in fetching job list:', err);
            showAlert('Unable to load jobs!');
        })
}

export function fetchJob(BeURL, showAlert, id, setJob, setApplication) {
    fetch(`${BeURL}/job-detail/${id}`, {
        credentials: 'include',
    })
        .then(async res => {
            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err.message || `Server ${res.status}`);
            }
            return res.json();
        })
        .then(data => {
            if (data.success) {
                setJob(data.job);
                setApplication(data.fetchApplications);
            }
            else showAlert(data.message)
        })
        .catch(err => {
            console.error('Error in fetching job details:', err);
            showAlert('Trouble in connecting to the Server! Please try again later.');
        })
}

export function fetchJobDetail(BeURL, showAlert, slug, setJob, setApplication) {
    console.log("bhsgf", slug )
    fetch(`${BeURL}/job-details/${slug}`, {
        credentials: 'include',
    })
        .then(async res => {
            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err.message || `Server ${res.status}`);
            }
            return res.json();
        })
        .then(data => {
            if (data.success) {
                setJob(data.job);
                setApplication(data.fetchApplications);
            }
            else {
                showAlert(data.message)
                console.log("datajhdg" , data.message)
            }
                
        })
        .catch(err => {
            console.error('Error in fetching job details:', err);
            showAlert('Trouble in connecting to the Server! Please try again later.');
        })
}